<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">

      <b-col cols="12" md="4">

        <div class="payment" :ref="`paymentCheckout`"></div>
        <button class="btn btn-danger btn-block mt-4" @click="cancelPayment">Cancel Transaction</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import AdyenCheckout from '@adyen/adyen-web';
import "@adyen/adyen-web/dist/adyen.css";
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins'
import moment from "moment";
const API_URL = process.env.API_URL;
const BASE_URL = process.env.BASE_URL;
const paymentMethodsConfig = {
  shopperReference: 'musicverse web',
  reference: '',
  countryCode: '',
  amount: {
    value: 0,
    currency: ''
  }
};
const paymentsDefaultConfig = {
  shopperReference: 'musicverse web', //gau
  reference: '', //di isi field 'identifier' dari api list credit amount. concat identifier-user_id
  countryCode: '',
  channel: '',
  returnUrl: '',
  amount: {
    value: 0,
    currency: ''
  },
};
export default {
  name: "SubscriptionCheckoutPage",
  mixins:[helperMixins],
  data() {
    return {
      mixins:[helperMixins],
      paymentMethodsConfig:paymentMethodsConfig,
      paymentsDefaultConfig:paymentsDefaultConfig,
      successUrl:'',
      failedUrl:'',
    }
  },
  mounted(){
    this.successUrl = BASE_URL+'/#/subscription-success';
    this.failedUrl = BASE_URL+'/#/transaction-failed';
    this.paymentMethodsConfig = {...this.paymentMethodsConfig,
      shopperReference:`subscription-${this.getUser.data.id}`,
      reference:`${this.subscriptionTrxData.identifier}-${this.getUser.data.id}`,
      countryCode:this.subscriptionTrxData.country,
      amount: {
        value: this.subscriptionTrxData.price,
        currency: this.subscriptionTrxData.currency
      },
    };
    this.paymentsDefaultConfig = {...this.paymentsDefaultConfig,
      shopperReference:`subscription-${this.getUser.data.id}`,
      reference:`${this.subscriptionTrxData.identifier}-${this.getUser.data.id}`,
      countryCode:this.subscriptionTrxData.country,
      channel: 'Web',
      returnUrl: this.successUrl,
      amount: {
        value: this.subscriptionTrxData.price,
        currency: this.subscriptionTrxData.currency
      },
    }
    this.initCheckout();
  },
  computed:{
    ...mapGetters('PaymentModule', ['subscriptionTrxData']),
    ...mapGetters('AuthModule', ['getUser']),
  },
  methods:{
    ...mapActions('PaymentModule', ['requestPaymentMethodsSubscription','requestClientKey',
      'requestMakePaymentSubscription','removePaymentDataSubscription','setPaymentDataSubscription','setPaymentError']),
    ...mapActions('NotificationModule', ['setLoading','unsetLoading']),
    cancelPayment(){
      Vue.swal({
        title: 'Warning',
        text: 'Are you sure to want to cancel this transaction?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if(result.value){
          this.removePaymentDataSubscription();
          this.setLoading();
          setTimeout(()=>{
            this.unsetLoading();
            this.$router.push({ name: 'HomePage' });
          },1000)

        }
      });
    },
    async  handleSubmission(state, component) {
      try {
        const paymentsConfig = {
          ...this.paymentsDefaultConfig,
        };
        const paymentRequest = {
          ...paymentsConfig,
          ...state.data
        };
        const res = await this.requestMakePaymentSubscription(paymentRequest);
        window.fbq('track', 'InitiateCheckout');
        this.handleServerResponse(res,component);
      } catch (error) {
        console.error(error);
        alert("Error occurred. Look at console for details");
      }
    },
    handleServerResponse(res, component) {
      const {redirect,content} = res;
      if (content.action) {
        component.handleAction(content.action);
      } else {
        switch (content.result_code) {
          case "Authorised":
            let data = {...this.subscriptionTrxData,payment:{
                error:0,
                msg:content.message
              }};
            this.setPaymentDataSubscription(data);
            setTimeout(()=>{
              window.location.href = this.successUrl;
            },500)
            break;
          case "Pending":
          case "Received":
            window.location.href = "/result/pending";
            break;
          case "Refused":
            this.setPaymentError({
              msg:content.message,
              type:'subscription'
            })
            window.location.href = this.failedUrl;
            break;
          default:
            this.setPaymentError({
              msg:content.message,
              type:'subscription'
            })
            window.location.href = this.failedUrl;
            break;
        }
      }
    },
    async  initCheckout() {
      try {
        const paymentMethods = await this.requestPaymentMethodsSubscription(this.paymentMethodsConfig);
        const clientKey = await this.requestClientKey();
        const configuration = {
          paymentMethodsResponse: paymentMethods,
          clientKey,
          environment: "test",
          showPayButton: true,
          removePaymentMethods: ['paysafecard', 'c_cash'],
          ideal: {
            showImage: true,
          },
          paymentMethodsConfiguration: {
            ideal: {
              showImage: true,
            },
            card: {
              // hasHolderName: true,
              // holderNameRequired: true,
              name: "Credit or debit card",
              amount: {
                value: this.convertPriceAdyen(this.subscriptionTrxData.currency,this.subscriptionTrxData.price),
                currency: this.subscriptionTrxData.currency
              },
            },
          },
          onSubmit: async (state, component) => {
            if (state.isValid) {
              await this.handleSubmission(state, component);
            }
          },
        };

        const checkout = new AdyenCheckout(configuration);
        const integration = checkout.create('dropin').mount(this.$refs['paymentCheckout']);
      } catch (error) {
        console.error(error);
        alert("Error occurred. Look at console for details");
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/SubscriptionCheckout.vue